
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/module/assets/categories",
      function () {
        return require("private-next-pages/module/assets/categories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/module/assets/categories"])
      });
    }
  